var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FolderTagPreview',{attrs:{"id":_vm.id,"icon":"icon-tag","name":_vm.displayName,"path":_vm.displayName,"file-list":_vm.fileList}})}
var staticRenderFns = []

export { render, staticRenderFns }